import { computed, Injectable } from "@angular/core";
import { OrderWizardState } from "../_state/order-wizard.state";
import { OrderWizardService } from "./order-wizard.service";

@Injectable({ providedIn: 'root' })
export class OrderWizardNavigationService  {
direction: 'forward' | 'backward' = 'forward';
animating: boolean = false;
activeStep = computed(() => this._state.orderWizard()?.activeStep??0);

stepList = [
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.order' },
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.pickup' },
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.ident' },
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.diligence' },
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.cgv' },
    { title: 'i18n.app.features.pages.order.wizard.common.header.step.summary' }
    
  ]

  constructor(
    public _state: OrderWizardState,
    public _orderWizardService: OrderWizardService
  ) {

  }
  
  nextStep() {
    this.changeStep('forward');
  }

  prevStep() {
    this.changeStep('backward');
  }

  changeStep(direction: 'forward' | 'backward') {
    this.animating = true;

    this.direction = direction;

    setTimeout(() => {
      direction == 'forward'
      ? this._state.nextStep()
      : this._state.prevStep();
      setTimeout(() => {
        this.animating = false;
      }, 50);

    }, 200); // durée sortie
  }

  getStepState(index: number): 'done' | 'current' | 'todo' {
    if (index < this.activeStep()) return 'done';
    if (index === this.activeStep()) return 'current';
    return 'todo';
  }

  getStepClasses(index: number) {
    const state = this.getStepState(index);

    return {
      'bg-secondary-100 text-secondary-600 border border-secondary-200': state === 'done',
      'bg-primary-500 text-white': state === 'current',
      'bg-gray-100 text-gray-600': state === 'todo'
    };
  }

  selectStep(step: number) {
    // if (step <= this.orderService.maxValideStep() + 1)
    //     this.orderService.currentStep.set(step)
  }

  isNextDisabled(): boolean {
    switch(this.activeStep()) {
      //purchase
      case(0): {
        const hasException = !this._orderWizardService.isStepValidated(1);
        return hasException;
      }
      //pickup point
      case(1): {
        const hasException = !this._orderWizardService.isStepValidated(2);
        return hasException;
      }
      //identification step
      case(2): {
        const hasException = !this._orderWizardService.isStepValidated(3);
        return hasException;
      }
      //Due diligence
      case(3): {
        const hasException = !this._orderWizardService.isStepValidated(4) || !this._orderWizardService.isStepCertified(4);
        
        // console.log('this._orderWizardService.isStepValidated(4)', this._orderWizardService.isStepValidated(4));
        // console.log('this._orderWizardService.isStepCertified(4)', this._orderWizardService.isStepCertified(4));
        // console.log('step03-next-hasException', hasException);
        return hasException;
      }
      //CGV
      case(4): {
        const hasException = !this._orderWizardService.isStepCertified(5); 
        return hasException;
      }
    }

    return false;
  }

  isNullOrWhiteSpace(value: unknown): boolean {
    return typeof value !== 'string' || !value.trim();
  }

  


 
}